import { render } from "./SliderComponent.vue?vue&type=template&id=cff1e4b4&scoped=true"
import script from "./SliderComponent.vue?vue&type=script&lang=js"
export * from "./SliderComponent.vue?vue&type=script&lang=js"

import "./SliderComponent.vue?vue&type=style&index=0&id=cff1e4b4&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cff1e4b4"]])

export default __exports__